import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import { getDefaultVsic } from '../../../../helper'
import InsuranceService from '../../core/InsuranceService'

export const postLiquidityAndSolvencyAndCoverAge = createAsyncThunk(
  'companyAnalysis/industryAnalysis/insurance/liquiditySolvencyCoverage',
  async (params, { rejectWithValue }) => {
    try {
      if (params?.isDynamicReport) {
        const {
          vsics,
          companyInfo = {},
          defaultIndustryId,
          compareIndustryId,
        } = params || {}

        const defaultVsicId =
          defaultIndustryId || getDefaultVsic(vsics, companyInfo.mainVsicId).id

        const res = await InsuranceService.postLiquidityAndSolvencyAndCoverAge({
          vsicDefault: defaultVsicId,
          vsicCompare: compareIndustryId,
          organizationId: companyInfo?.organizationId,
        })

        return res.success
          ? { data: res.data, defaultVsicId }
          : rejectWithValue({ isLoading: false })
      } else {
        const { vsicDefault, ...others } = params || {}
        const res = await InsuranceService.postLiquidityAndSolvencyAndCoverAge({
          vsicDefault,
          ...others,
        })

        return res.success
          ? { data: res.data, defaultVsicId: vsicDefault }
          : rejectWithValue({ isLoading: false })
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadLiquiditySolvencyCoverage = createAsyncThunk(
  'companyAnalysis/industryAnalysis/insurance/liquiditySolvencyCoverage/export',
  async (params) => {
    try {
      const res =
        await InsuranceService.downloadLiquidityAndSolvencyAndCoverAge(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
